/**
 * Puts `text` on the clipboard. Resolves true when it got there.
 *
 * The async Clipboard API first. In-app browsers and older WebViews often
 * lack it or refuse it, so fall back to the old select-and-copy on a
 * temporary text field (iOS needs a real selection range for that). When both
 * fail, the caller shows the text for the driver to copy by hand.
 */
const copyWithSelection = (text) => {
  const { body } = document;
  if (!body || typeof document.execCommand !== 'function') return false;

  const field = document.createElement('textarea');
  field.value = text;
  field.setAttribute('readonly', '');
  // Off to the side, and 16px so iOS does not zoom in on focus.
  Object.assign(field.style, {
    position: 'fixed', top: '0', left: '-9999px', fontSize: '16px', opacity: '0',
  });
  body.appendChild(field);
  try {
    field.focus();
    field.select();
    field.setSelectionRange(0, text.length);
    return document.execCommand('copy') === true;
  } catch {
    return false;
  } finally {
    body.removeChild(field);
  }
};

export default async function copyText(text) {
  try {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Refused (no permission, insecure context): try the fallback.
  }
  return copyWithSelection(text);
}
